<template>

<app-section>

    <app-filter>

        <app-input icon="date" :is-inline="true" type="date" placeholder="From" v-model="filter.from" />
        <app-input type="date" :is-inline="true" placeholder="To" v-model="filter.to" />
        <app-input icon="hospital" :is-inline="true" type="select" placeholder="Select hospital" reset-option="All hospitals" v-model="filter.hospital" :options="hospitals" />

    </app-filter>

    <app-panel :is-loading="is.loading && !is.initialised" :is-empty="is.empty" empty-message="No records found.">

        <app-table>
            <thead>
                <tr>
                    <th width="100">Pseudo ID</th>
                    <th align="center" width="100">Score</th>
                    <th>Hospital</th>
                    <th align="center" width="80">Completed</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ item.reference }}</td>
                    <td align="center">{{ item.score }}</td>
                    <td>{{ item.hospital }}</td>
                    <td align="center"><div class="completed" :class="{'is-active': item.completed}" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <app-actions>

        <app-button text="Download as .xls" theme="grey" v-on:click.native="onExportClick('xls')" />

    </app-actions>

</app-section>

</template>

<script>

import mixCollection from '@/mixin/collection'
import Vue from 'vue'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'dashboard/data',
            filter: {
                from: null,
                to: null,
                hospital: null
            },
            hospitals: []
        }
    
    },

    methods: {

        onExportClick: function(type) {
        
            this.$api.get(this.api, {
                from: this.filter.from,
                to: this.filter.to,
                hospital: this.filter.hospital,
                export: type
            }).then(function(json) {
            
                window.location.href = json.url
                
            })

        },
    
        afterLoad: function(json) {

            Vue.set(this, 'hospitals', json.hospitals)
        
        }
    
    }

}

</script>

<style scoped>

.completed {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
    background-repeat: no-repeat;
    background-image: url(~@/assets/icon.pending.png);
}

.completed.is-active {
    background-image: url(~@/assets/icon.tick.png);
}

</style>
